module.exports = __webpack_public_path__ + "static/media/casino6.cee9e2c9.jpg";